<template>
    <div>
                <div class="vx-card p-6">
                    <div class="vx-row">
                        <div class="vx-col md:w-1/4 w-full">
                            <label class="vs-input--label">{{ $t('multipleChoice.title') }}</label>
                            <vs-input class="w-full" v-model="schoolQuizName" type="text" data-vv-validate-on="blur" />
                        </div>
                        <div class="vx-col md:w-1/4 w-full ">
                    <label class="vs-input--label">{{ $t('timeKeeping.times') }}</label>
                    <div class="flex-grow">
                        <date-range-picker class="w-full" ref="picker" :locale-data="{ format: 'dd/mm/yyyy' }"
                            :opens="'right'" @update="dateRangePicker" v-model="dateRange">
                        </date-range-picker>
                    </div>
                </div>
                        <vs-button icon="icon-search" icon-pack="feather" color="primary" class="mt-6 ml-4"
                            @click="getHistoryExam">
                            {{ this.$t('multipleChoice.search') }}
                        </vs-button>
                    </div>

                </div>
                <div class="vx-card px-4">
                    <ag-grid-vue style="height: 55vh" ref="agGridTable"
                        class="ag-theme-material w-100 my-4 ag-grid-table" :columnDefs="columnDefs"
                        :defaultColDef="defaultColDef" :rowData="dataHistoryExam" :animateRows="true"
                        :localeText="{ noRowsToShow: this.$t('menuCustomer.noRowsToShow') }"
                        @grid-ready="onGridReady"
                        :autoSizeStrategy="autoSizeStrategy">
                    </ag-grid-vue>
                    <div class="vx-row mt-8" v-if="totalElements > 0">
                        <div class="vx-col md:w-1/2 w-full">
                            <span class="content-page font-bold">{{ this.$t('dashboard.display') }}: </span>
                            <span class="text-page">
                                {{ countElementPage > totalElements ? totalElements : countElementPage }} / {{
                                totalElements
                            }}
                            </span>
                        </div>
                        <div class="vx-col md:w-1/2 w-full">
                            <vs-pagination :total="totalPages" v-model="currentPage" @change="loadPage" />
                        </div>
                    </div>
                </div>
    </div>
</template>
<script>
import vSelect from 'vue-select';
import { AgGridVue } from "ag-grid-vue";
import CellRendererHistoryExam from "./cell-renderer/CellRendererHistoryExam.vue";
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import moment from "moment";
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import { ModuleRegistry } from '@ag-grid-community/core';
import DateRangePicker from '../../../components/vue2-daterange-picker/components/DateRangePicker.vue'

ModuleRegistry.registerModules([ClientSideRowModelModule]);

export default {
    components: {
        vSelect,
        AgGridVue,
        CellRendererHistoryExam,
        DateRangePicker,
    },
    data() {
        return {
            gridApi: null,
            typeOfExercise: null,
            selectPriority: null,
            schoolQuizName: null,
            dataHistoryExam: [],
            pageNumber: 0,
            pageSize: 20,
            defaultColDef: {},
            columnDefs: [
                {
                    headerName: this.$t('multipleChoice.stt'),
                    field: 'stt',
                    width: 100
                },
                {
                    headerName: this.$t('multipleChoice.title'),
                    field: 'title',
                    width: 300,
                },
                {
                    headerName: this.$t('multipleChoice.createDate'),
                    field: 'startDate',
                    width: 250
                },
                {
                    headerName: this.$t('multipleChoice.updatedDate'),
                    field: 'endDate',
                    width: 250
                },
                {
                    headerName: this.$t('multipleChoice.actions'),
                    field: 'actions',
                    width: 200,
                    cellRenderer: 'CellRendererHistoryExam',
                    suppressSizeToFit: true,
                },
            ],

            autoSizeStrategy: {
                type: 'fitGridWidth',
            },
            totalPages: 0,
            countElementPage: 0,
            totalElements: 0,
            currentPage: 1,
            dateRange: {
                endDate: null,
                startDate: null,
            },

        }
    },
    created() {
        this.getHistoryExam();
    },
    methods: {
        dateRangePicker: function () {
            this.dateRange.startDate = new Date(this.dateRange.startDate.setHours(0, 0, 0, 0));
            this.dateRange.endDate = new Date(this.dateRange.endDate.setHours(23, 59, 59, 999));
        },
        onGridReady(params) {
            this.gridApi = params.api;
        },
        loadPage: function (currentPage) {
            if (parseInt(currentPage) - 1 != this.pageNumber) {
                this.pageNumber = parseInt(currentPage) ? parseInt(currentPage) - 1 : 0;
                this.getHistoryExam();
            }
        },
        getHistoryExam(){
            let body = {
                pageNumber:this.pageNumber,
                pageSize:this.pageSize,
                startDate:this.dateRange.startDate,
                endDate:this.dateRange.endDate,
                title:this.schoolQuizName
            }
            this.$vs.loading();
            this.$crm.post('/school-quiz/find-by-condition-to-quiz', body).then((response) => {
                this.dataHistoryExam = response.data.content.map(el => {
                    el.stt = response.data.content.indexOf(el) + 1;
                    el.startDate = el.startDate ? moment(el.startDate).format('DD/MM/YYYY HH:mm') : '';
                    el.endDate = el.endDate ? moment(el.endDate).format('DD/MM/YYYY HH:mm') : '';
                    return el;
                })
                this.countElementPage = this.currentPage * this.pageSize;
                this.totalElements = this.dataHistoryExam.length
                this.totalPages = response.data.totalPages
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
    },
    watch: {
        // '$store.state.isUpdateQuestion'(val) {
        //     if (val) {
        //         this.$store.commit('UPDATE_QUESTION', false);
        //         this.getHistoryExam();
        //
        //     }
        // }
    },
}
</script>
<style>
.required::after {
    content: '* ';
    color: red;
}
</style>
